import { noop } from 'lodash';
import React from 'react'
import Avatar from 'react-avatar';
import { Currency } from 'types';
import { Gig } from 'types/campaign/collaborations';
import { CampaignGigOption } from 'types/campaign/milestones';
import { formatAmount } from 'utils/helpers';

interface CampaignGigProps {
    gig: Gig,
    gigType: string,
    onPlayBtnClick: (gig: Gig) => void,
    showCTA?: boolean,
    enableOptionsSelection?: boolean,
    selectedOptions?: CampaignGigOption[] | null
    onOptionSelection?: (data: any) => void
    quickRepost?: boolean
    currency: Currency
}

const CampaignGig: React.FC<CampaignGigProps> = ({ gig, gigType, onPlayBtnClick, showCTA = true, enableOptionsSelection = false, onOptionSelection=noop, currency, selectedOptions=null, quickRepost = false }) => {
    return (
        <div className="gig">
            <div className='d-flex gap-2'>
                {
                    gig.thumbnail_url ? (
                        <div className="bg-image gig-image bgc-content" onClick={(e) => {
                            if (gigType === 'repost') {
                                // onPlayBtnClick(gig);
                                e.stopPropagation();
                                window.open(gig.properties?.permalink ?? "#", '_blank');
                            }
                        }} style={{ backgroundImage: `url(${gig.thumbnail_url})` }}></div>
                    ) : (
                        <Avatar name={gig.name} size='48' className='gig-image' />
                    )
                }

                <div className="d-flex flex-column justify-content-center gap-2">
                    <span className='gig-name text-start fs-14px'>{gig.name}</span>
                    {
                        gigType === 'repost' && !quickRepost &&
                        <span className="cursor-pointer fs-10 fw-bold text-primary" onClick={(e) => {
                            e.stopPropagation();
                            onPlayBtnClick(gig);
                        }}>Download</span>
                    }
                    {
                        gig.value && gigType === 'product_review' &&
                        <span className='gig-value text-start'>{formatAmount(gig.value, currency?.code, currency?.symbol, currency?.locale)}</span>
                    }
                    {
                        Array.isArray(gig.options) && gig.options.length > 0 &&
                        <>
                            {
                                enableOptionsSelection ? (
                                    <div className='d-flex flex-column gap-2'>
                                        {
                                            gig.options.map((option, i) => {
                                                return (
                                                    <div className='d-flex flex-column' key={i}>
                                                        <span className='fw-bold text-dark'>{option.label}</span>
                                                        <div className="d-flex align-items-center justify-content-start flex-wrap gap-2">
                                                            {
                                                                option.values.map((value, j) => {
                                                                    const selectedOption = selectedOptions?.find((so) => so.label === option.label);
                                                                    return (
                                                                        <span key={j} onClick={() => {
                                                                            let options = selectedOptions ? [...selectedOptions] : [];
                                                                            options[i] = options[i] ? {...options[i]} : {label: option.label, values: []};
                                                                            options[i].values = [...options[i].values];
                                                                            if(options[i].values.includes(value)){
                                                                                options[i].values = options[i].values.filter((val) => val !== value);
                                                                            }else{
                                                                                options[i].values = [value]
                                                                            }
                                                                            onOptionSelection(options);
                                                                        }} className={`option-btn cursor-pointer ${selectedOption?.values?.includes(value) ? 'selected' : ''}`}>{value}</span>
                                                                    )
                                                                })
                                                            }
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                ) : (
                                    <div className='d-flex flex-column gap-0'>
                                        {
                                            gig.options.map((option, i) => {
                                                return (
                                                    <span key={i}><b>{option.label}: </b> {option.values.join(', ')}</span>
                                                )
                                            })
                                        }
                                    </div>
                                )
                            }
                        </>
                    }
                </div>
            </div>
            {
                showCTA &&
                <div className="gig-cta">
                    {
                        gigType === 'product_review' &&
                        <a onClick={(e) => e.stopPropagation()} href={gig.properties?.url ?? "#"} target='_blank' rel='noreferral'>View Product</a>
                    }
                    {
                        gigType === 'repost' &&
                        // <span className="cursor-pointer" onClick={(e) => {
                        //     e.stopPropagation();
                        //     onPlayBtnClick(gig)
                        // }}>View Post</span>
                        <a onClick={(e) => e.stopPropagation()} href={gig.properties?.permalink ?? "#"} target='_blank' rel='noreferral'>View Post</a>
                    }
                </div>
            }
        </div>
    )
}

export default CampaignGig